import { getFullUrl } from 'hubspot-url-utils';
import { memo, useCallback } from 'react';
import getCurrentApp from '../../utils/getCurrentApp';
import getCurrentUrlWithoutPortalId from '../../utils/getCurrentUrlWithoutPortalId';
import AbstractBanner from './AbstractBanner/AbstractBanner';
import useUsageTracker from '../../hooks/useUsageTracker';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ImpersonationBanner = ({
  userData
}) => {
  const showBanner = !!userData.actingUserId;
  const {
    track
  } = useUsageTracker();
  const bannerRefCallback = useCallback(element => {
    if (element && track) {
      track('userImpersonation', {
        currentApp: getCurrentApp(),
        currentUrl: getCurrentUrlWithoutPortalId()
      });
    }
  }, [track]);
  if (!showBanner) {
    return null;
  }
  const {
    firstName = '',
    lastName = ''
  } = userData ? userData.user : {};
  const userName = formatName({
    firstName,
    lastName
  });
  const hintText = I18n.text('alerts.impersonation.hint');
  const signOutText = I18n.text('app.signOut');
  const logoutUrl = `${getFullUrl('app')}/login-api/v1/logout/all`;
  const activeText = I18n.text('alerts.impersonation.active-userName', {
    userName
  });
  return /*#__PURE__*/_jsx(AbstractBanner, {
    isCloseable: false,
    type: 'info',
    "data-test-id": `user-impersonation-banner`,
    title: activeText,
    ref: bannerRefCallback,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [hintText, /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        marginInline: "300",
        size: "small",
        href: logoutUrl,
        children: signOutText
      })]
    })
  });
};
export default /*#__PURE__*/memo(ImpersonationBanner);